import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "tab-shell" }
const _hoisted_2 = { class: "tab-head" }
const _hoisted_3 = { class: "filter-tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "form-card"
}
const _hoisted_6 = { class: "form-title" }
const _hoisted_7 = { class: "form-grid" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "field" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "field field--full" }
const _hoisted_15 = { class: "items-section" }
const _hoisted_16 = { class: "items-header" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "items-empty-hint"
}
const _hoisted_23 = {
  key: 0,
  class: "form-error"
}
const _hoisted_24 = { class: "form-actions" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_27 = {
  key: 2,
  class: "empty-hint"
}
const _hoisted_28 = {
  key: 3,
  class: "cards-grid"
}
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { class: "card-header-row" }
const _hoisted_31 = { class: "card-title" }
const _hoisted_32 = {
  key: 0,
  class: "card-meta"
}
const _hoisted_33 = {
  key: 1,
  class: "card-meta"
}
const _hoisted_34 = {
  key: 2,
  class: "card-meta"
}
const _hoisted_35 = {
  key: 3,
  class: "card-value-row"
}
const _hoisted_36 = { class: "card-footer" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "tab-title" }, "Ordens de Compra", -1)),
      (!_ctx.showForm)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openForm()))
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("svg", {
              width: "13",
              height: "13",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2"
            }, [
              _createElementVNode("line", {
                x1: "12",
                y1: "5",
                x2: "12",
                y2: "19"
              }),
              _createElementVNode("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
              })
            ], -1),
            _createTextVNode(" Nova OC ", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusFilters, (f) => {
        return (_openBlock(), _createElementBlock("button", {
          key: f.value,
          class: _normalizeClass(["filter-tab", { active: _ctx.statusFilter === f.value }]),
          type: "button",
          onClick: ($event: any) => (_ctx.statusFilter = f.value)
        }, _toDisplayString(f.label), 11, _hoisted_4))
      }), 128))
    ]),
    (_ctx.showForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.editId ? 'Editar Ordem de Compra' : 'Nova Ordem de Compra'), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "field-label" }, "Fornecedor *", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "field-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.fornecedorId) = $event))
              }, [
                _cache[11] || (_cache[11] = _createElementVNode("option", { value: "" }, "Selecione...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, (s) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: s.id,
                    value: s.id
                  }, _toDisplayString(s.nomeFantasia || s.razaoSocial), 9, _hoisted_9))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.fornecedorId]
              ])
            ]),
            _createElementVNode("label", _hoisted_10, [
              _cache[14] || (_cache[14] = _createElementVNode("span", { class: "field-label" }, "Obra", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "field-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.projectId) = $event))
              }, [
                _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Selecione...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: p.id,
                    value: p.id
                  }, _toDisplayString(p.name), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.projectId]
              ])
            ]),
            _createElementVNode("label", _hoisted_12, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "field-label" }, "Prazo de Entrega", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                type: "date",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.prazoEntrega) = $event))
              }, null, 512), [
                [_vModelText, _ctx.form.prazoEntrega]
              ])
            ]),
            _createElementVNode("label", _hoisted_13, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "field-label" }, "Condição de Pagamento", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.condicaoPagamento) = $event)),
                placeholder: "Ex: 30 dias, boleto"
              }, null, 512), [
                [_vModelText, _ctx.form.condicaoPagamento]
              ])
            ]),
            _createElementVNode("label", _hoisted_14, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "field-label" }, "Observações", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "field-input field-textarea",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.observacoes) = $event)),
                rows: "2",
                placeholder: "Notas adicionais..."
              }, null, 512), [
                [_vModelText, _ctx.form.observacoes]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "items-title" }, "Itens", -1)),
              _createElementVNode("button", {
                class: "btn-add-item",
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
              }, "+ Adicionar item")
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.items, (item, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: idx,
                class: "item-row"
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "field-input item-desc",
                  "onUpdate:modelValue": ($event: any) => ((item.descricao) = $event),
                  placeholder: "Descrição do item"
                }, null, 8, _hoisted_17), [
                  [_vModelText, item.descricao]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "field-input item-qty",
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((item.quantidade) = $event),
                  min: "1",
                  placeholder: "Qtd"
                }, null, 8, _hoisted_18), [
                  [
                    _vModelText,
                    item.quantidade,
                    void 0,
                    { number: true }
                  ]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "field-input item-unit",
                  "onUpdate:modelValue": ($event: any) => ((item.unidade) = $event),
                  placeholder: "Un."
                }, null, 8, _hoisted_19), [
                  [_vModelText, item.unidade]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "field-input item-value",
                  type: "number",
                  "onUpdate:modelValue": ($event: any) => ((item.valorUnitario) = $event),
                  min: "0",
                  step: "0.01",
                  placeholder: "Vlr unit."
                }, null, 8, _hoisted_20), [
                  [
                    _vModelText,
                    item.valorUnitario,
                    void 0,
                    { number: true }
                  ]
                ]),
                _createElementVNode("button", {
                  class: "btn-remove-item",
                  type: "button",
                  onClick: ($event: any) => (_ctx.removeItem(idx))
                }, "✕", 8, _hoisted_21)
              ]))
            }), 128)),
            (_ctx.form.items.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Nenhum item adicionado."))
              : _createCommentVNode("", true)
          ]),
          (_ctx.formError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.formError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("button", {
              class: "btn-save",
              type: "button",
              disabled: _ctx.saving,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, _toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar'), 9, _hoisted_25),
            _createElementVNode("button", {
              class: "btn-cancel",
              type: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
            }, "Cancelar")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Carregando..."))
      : (_ctx.filteredOcs.length === 0 && !_ctx.showForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[19] || (_cache[19] = [
            _createElementVNode("svg", {
              width: "36",
              height: "36",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.4"
            }, [
              _createElementVNode("path", { d: "M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" }),
              _createElementVNode("line", {
                x1: "3",
                y1: "6",
                x2: "21",
                y2: "6"
              }),
              _createElementVNode("path", { d: "M16 10a4 4 0 0 1-8 0" })
            ], -1),
            _createTextVNode(" Nenhuma ordem de compra. ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOcs, (oc) => {
              return (_openBlock(), _createElementBlock("article", {
                key: oc.id,
                class: "oc-card"
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, "OC #" + _toDisplayString(oc.numero || oc.id.slice(-6).toUpperCase()), 1),
                    _createElementVNode("span", {
                      class: _normalizeClass(["status-chip", _ctx.ocStatusClass(oc.status)])
                    }, _toDisplayString(_ctx.ocStatusLabel(oc.status)), 3)
                  ]),
                  (oc.fornecedorNome)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(oc.fornecedorNome), 1))
                    : _createCommentVNode("", true),
                  (oc.prazoEntrega)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Entrega: " + _toDisplayString(_ctx.formatDate(oc.prazoEntrega)), 1))
                    : _createCommentVNode("", true),
                  (oc.condicaoPagamento)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, "Pagto: " + _toDisplayString(oc.condicaoPagamento), 1))
                    : _createCommentVNode("", true),
                  (oc.valorTotal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.formatCurrency(oc.valorTotal)), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("button", {
                    class: "card-btn",
                    type: "button",
                    onClick: ($event: any) => (_ctx.openForm(oc))
                  }, "Editar", 8, _hoisted_37),
                  (oc.status === 'emitida')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "card-btn card-btn--ok",
                        type: "button",
                        onClick: ($event: any) => (_ctx.updateStatus(oc.id, 'confirmada'))
                      }, "Confirmar", 8, _hoisted_38))
                    : _createCommentVNode("", true),
                  (oc.status === 'confirmada')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "card-btn card-btn--ok",
                        type: "button",
                        onClick: ($event: any) => (_ctx.updateStatus(oc.id, 'entregue'))
                      }, "Entregue", 8, _hoisted_39))
                    : _createCommentVNode("", true),
                  (oc.status !== 'cancelada' && oc.status !== 'entregue')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        class: "card-btn card-btn--warn",
                        type: "button",
                        onClick: ($event: any) => (_ctx.updateStatus(oc.id, 'cancelada'))
                      }, "Cancelar", 8, _hoisted_40))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ]))
  ]))
}